import { Component, OnInit, OnDestroy, ChangeDetectorRef, Input, ElementRef } from '@angular/core';
import { OrderService } from '@services/order.service';
import { ActivatedRoute } from '@angular/router';
import { VendorsBaseComponent } from '@components/admin/managed-board/base/vendors-base/vendors-base.component';
import { Vendor } from '@models/vendor';
import { VendorOrders } from '@models/vendor-order';

@Component({
  selector: 'app-managed-board-awaiting-frames',
  templateUrl: './managed-board-awaiting-frames.component.html',
  styleUrls: ['./managed-board-awaiting-frames.component.css'],
})
export class ManagedBoardAwaitingFramesComponent extends VendorsBaseComponent implements OnInit, OnDestroy {
  @Input() public section: string = 'awaiting frames';
  private readonly pressCapture = (event: Event) => this.flashButton(event);

  constructor(
    public orderService: OrderService,
    public cdRef: ChangeDetectorRef,
    public route: ActivatedRoute,
    private host: ElementRef<HTMLElement>
  ) {
    super(orderService, cdRef, route);
    // Parent VendorsBaseComponent defaults section to 'orders'; force awaiting-frames
    // so this board never loads Stack To-Do orders.
    this.section = 'awaiting frames';
  }

  ngOnInit() {
    this.section = 'awaiting frames';
    super.ngOnInit();
    this.host.nativeElement.addEventListener('click', this.pressCapture, true);
  }

  ngOnDestroy() {
    this.host.nativeElement.removeEventListener('click', this.pressCapture, true);
  }

  get vendorTotal(): number {
    return this.dataSource?.data?.length || 0;
  }

  get totalFrames(): number {
    return (this.dataSource?.data || []).reduce(
      (sum, row) => sum + this.frameCount(row),
      0
    );
  }

  frameCount(row: VendorOrders): number {
    return row?.orders?.length || 0;
  }

  patientCount(row: VendorOrders): number {
    return (row?.orders || []).filter((order) => !!order?.patient).length;
  }

  hasPatientOrder(row: VendorOrders): boolean {
    return this.patientCount(row) > 0;
  }

  vendorsLabel(count: number): string {
    return `${count} ${count === 1 ? 'vendor' : 'vendors'}`;
  }

  framesLabel(count: number): string {
    return `${count} ${count === 1 ? 'frame' : 'frames'}`;
  }

  patientsLabel(count: number): string {
    return `${count} ${count === 1 ? 'patient' : 'patients'}`;
  }

  vendorInitial(name: string): string {
    return (name || '?').trim().charAt(0).toUpperCase();
  }

  phoneOf(vendor: Vendor): string {
    return vendor?.repPhone || vendor?.phone || '';
  }

  emailOf(vendor: Vendor): string {
    return vendor?.repEmail || '';
  }

  telHref(phone: string): string {
    return 'tel:' + String(phone || '').replace(/[^\d+]/g, '');
  }

  flashButton(event: Event): void {
    const target = event.target as HTMLElement | null;
    const button = target?.closest('button') as HTMLButtonElement | null;
    if (!button || button.disabled) {
      return;
    }
    button.classList.remove('ao-pressed');
    void button.offsetWidth;
    button.classList.add('ao-pressed');
  }
}